import { useQuery } from "@tanstack/react-query";
import { apiClient, signApiRequest } from ".";
import { AxiosError } from "axios";
import { CustomerCredentials } from "../ui/customerDataStore";
import { captureException } from "@sentry/react";

export type DocumentHistory = {
  fid: string;
  sortKey: string;
  fileName: string;
  url: string;
};

const getDocumentHistoryById = async ({
  credentials,
}: {
  credentials: CustomerCredentials;
}) => {
  const signedRequest = await signApiRequest(
    "GET",
    `${import.meta.env.VITE_API_URL}/advice-document/document-history?fid=${credentials.identityId}`,
    credentials,
    { "content-type": "application/json" },
  );

  const response = await apiClient(signedRequest);
  return response.data;
};

export const useGetDocumentHistoryById = ({
  credentials,
  enabled = true,
}: {
  credentials: CustomerCredentials;
  enabled?: boolean;
}) => {
  const documentHistoryQuery = useQuery<DocumentHistory[], AxiosError>({
    queryKey: ["get-document-history-by-id"],
    queryFn: () => getDocumentHistoryById({ credentials }),
    retry: false,
    enabled,
    throwOnError: (error) => {
      captureException(error, {
        tags: {
          operation: "get-document-history-by-id",
          errorType: error.name || "UnknownError",
        },
        extra: {
          apiEndpoint: "/advice-document/document-history?fid=${identityId}",
        },
        level: "error",
      });
      return true;
    },
  });

  return documentHistoryQuery;
};
